var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 15H15.1663V9H18.6663L13.9997 4L9.33301 9H12.833V15Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 18H4.66634V11H2.33301V18C2.33301 19.103 3.37951 20 4.66634 20H23.333C24.6198 20 25.6663 19.103 25.6663 18V11H23.333V18Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUpload);
export default __webpack_public_path__ + "static/media/bx_upload.c547cc423ed0e4ff68314a437b4fe58e.svg";
export { ForwardRef as ReactComponent };